import React from "react";
import { Button } from "../ui/button";
import { ArrowRight, Sparkles, BadgeCheck } from "lucide-react";
import { IMAGES } from "../../data/mock";
import { useLang } from "../../i18n/LanguageContext";
import { WHATSAPP_URL } from "../../config";

export default function Hero() {
  const { t } = useLang();
  const openClaim = () => window.open(WHATSAPP_URL, "_blank", "noopener,noreferrer");

  return (
    <section id="top" className="relative overflow-hidden bg-[var(--aa-wine)] text-[var(--aa-cream)]">
      <div className="absolute inset-0">
        <img
          src={IMAGES.hero}
          alt="Resort at sunset"
          className="w-full h-full object-cover opacity-40 scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[var(--aa-wine)]/85 via-[var(--aa-wine)]/70 to-[var(--aa-wine)]"></div>
      </div>

      <div className="pointer-events-none absolute -top-40 -right-40 w-[520px] h-[520px] rounded-full border border-white/10"></div>
      <div className="pointer-events-none absolute -bottom-56 -left-40 w-[640px] h-[640px] rounded-full border border-white/5"></div>

      <div className="relative mx-auto max-w-6xl px-6 md:px-8 pt-20 md:pt-28 pb-24 md:pb-36 text-center">
        <div className="reveal in inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-white/25 bg-white/5 text-[11px] tracking-[0.22em] uppercase">
          <Sparkles className="w-3.5 h-3.5" />
          {t.hero.eyebrow}
        </div>

        <h1 className="reveal font-display font-light text-[44px] leading-[1.05] sm:text-6xl md:text-[76px] md:leading-[1.02] mt-7 max-w-4xl mx-auto">
          {t.hero.h1a}
          <br />
          <span className="italic font-normal text-[var(--aa-cream)]/95">
            {t.hero.h1b}
          </span>
        </h1>

        <p className="reveal max-w-2xl mx-auto mt-7 text-[15px] md:text-[17px] leading-relaxed text-[var(--aa-cream)]/80">
          {t.hero.p}
        </p>

        <div className="reveal mt-10 inline-flex flex-col items-center gap-7">
          <a
            href="#fineprint"
            className="group relative inline-flex items-center gap-3 pl-1.5 pr-6 py-1.5 rounded-full bg-[var(--aa-cream)] text-[var(--aa-wine)] hover:bg-white transition-colors shadow-[0_10px_40px_-15px_rgba(0,0,0,0.5)]"
          >
            <span className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-[var(--aa-wine)] text-[var(--aa-cream)]">
              <BadgeCheck className="w-4.5 h-4.5" strokeWidth={2.2} />
            </span>
            <span className="font-display italic text-xl md:text-2xl leading-none whitespace-nowrap">
              {t.hero.zero}{" "}
              <span className="text-[var(--aa-wine)]/55">
                {t.hero.ever}
                <sup className="text-[11px] ml-0.5 not-italic">*</sup>
              </span>
            </span>
          </a>
          <Button
            onClick={openClaim}
            className="group rounded-full bg-[var(--aa-cream)] hover:bg-white text-[var(--aa-wine)] px-7 py-6 text-[15px] font-semibold shadow-[0_10px_40px_-10px_rgba(0,0,0,0.4)]"
          >
            {t.hero.cta}
            <ArrowRight className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-1" />
          </Button>
          <div className="text-xs text-[var(--aa-cream)]/60">
            {t.hero.tagline}
          </div>
        </div>
      </div>
    </section>
  );
}
